import type { Breakpoint } from "@mui/material";
import { Container } from "@mui/material";
import type { ReactNode } from "react";

export function Page({
  children,
  maxWidth = "xl",
  gutterBottom = false,
}: {
  children: ReactNode;
  maxWidth?: Breakpoint | false;
  gutterBottom?: boolean;
}) {
  return (
    <Container
      component="main"
      maxWidth={maxWidth}
      sx={{
        paddingY: 2,
        bgcolor: "background.default",
        ...(gutterBottom && { paddingBottom: 6 }),
      }}
    >
      {children}
    </Container>
  );
}
